(() => {
  const fields = ['title', 'product_type', 'tag', 'vendor', 'variants.title', 'variants.sku', 'variants.barcode'];
  // Field-scoped queries are native Shopify syntax. Keep explicit customer syntax unchanged.
  function focusedQuery(value) {
    const term = value.trim().replace(/\s+/g, ' ');
    if (!term || term.length > 120 || /["\\:()*]/.test(term) || /\b(?:AND|OR|NOT)\b/.test(term) || /(^|\s)-\S/.test(term)) return value;
    return fields.map(field => `${field}:"${term}"`).join(' OR ');
  }
  document.addEventListener('submit', event => {
    const form = event.target.closest('[data-focused-search-form]');
    if (!form) return;
    const input = form.querySelector('[name="q"]');
    const query = focusedQuery(input.value);
    if (query === input.value) return;
    event.preventDefault();
    const url = new URL(form.action, location.origin);
    url.search = new URLSearchParams(new FormData(form)).toString();
    url.searchParams.set('q', query);
    location.assign(url.href);
  });
  document.addEventListener('click', event => {
    const link = event.target.closest('[data-focused-search-link]');
    if (!link || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const url = new URL(link.href, location.origin);
    const term = url.searchParams.get('q') || '';
    const query = focusedQuery(term);
    if (query === term) return;
    event.preventDefault();
    url.searchParams.set('q', query);
    location.assign(url.href);
  });
  let timer, controller;
  const input = document.querySelector('[data-predictive-input]');
  const results = document.querySelector('[data-predictive-results]');
  const initial = results?.innerHTML;
  input?.addEventListener('input', () => {
    clearTimeout(timer);
    controller?.abort();
    const term = input.value.trim();
    if (term.length < 2) {
      results.innerHTML = initial;
      input.setAttribute('aria-expanded', 'false');
      return;
    }
    timer = setTimeout(async () => {
      const request = new AbortController();
      controller = request;
      const load = async query => {
        const params = new URLSearchParams({q: query, 'resources[type]': 'product,collection,article,page', 'resources[limit]': '6', 'resources[options][unavailable_products]': 'last', section_id: 'predictive-search'});
        const response = await fetch(`${document.body.dataset.searchUrl || '/search/suggest'}?${params}`, {signal: request.signal});
        if (!response.ok) throw new Error('Search unavailable');
        return new DOMParser().parseFromString(await response.text(), 'text/html');
      };
      try {
        const query = focusedQuery(term);
        let parsed = await load(query);
        if (query !== term && parsed.querySelector('[data-predictive-count]')?.dataset.predictiveCount === '0') parsed = await load(term);
        if (request.signal.aborted || input.value.trim() !== term) return;
        const section = parsed.querySelector('.shopify-section');
        results.innerHTML = section ? section.innerHTML : '';
        input.setAttribute('aria-expanded', 'true');
      } catch (error) {
        if (error.name !== 'AbortError') input.setAttribute('aria-expanded', 'false');
      }
    }, 200);
  });
  const page = document.querySelector('[data-search-page]');
  // A misspelling or a content-only query can have no direct matches. Let Shopify's
  // ordinary search handle these, without broadening a customer's active filters.
  if (page?.dataset.searchFocused === 'true' && page.dataset.searchCount === '0' && page.dataset.searchFiltered === 'false') {
    const url = new URL(location.href);
    if (!url.searchParams.has('page')) {
      url.searchParams.set('q', page.dataset.searchTerm);
      location.replace(url.href);
    }
  }
})();
